import {connect} from 'react-redux';
import Toast from './Toast';
import toastActions from '../../redux/actions/toast.actions';

const mapStateToProps = state => ({
    toasts: state.get('toasts')
});

const mapDispatchToProps = dispatch => ({
    dismissToastItem: id => dispatch(toastActions.dismissToast(id))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Toast);
